import Card from "@mui/material/Card"
import Grid from "@mui/material/Grid"
import Icon from "@mui/material/Icon"
import MDBox from "components/MDBox"
import MDButton from "components/MDButton"
import config from "config"
import Footer from "monitor/Footer"
import DashboardLayout from "monitor/LayoutContainers/DashboardLayout"
import DashboardNavbar from "monitor/Navbars/DashboardNavbar"
import DataTable from "monitor/Tables/DataTable"
import { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import Chip from "@mui/material/Chip"

import Swal from "sweetalert2"
import { showToast } from "utils/swalToast"
import MDTypography from "components/MDTypography"
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material"

function Eventos() {
  const [data, setData] = useState([])
  const [empresas, setEmpresas] = useState([])
  const [selectedEmpresas, setSelectedEmpresas] = useState("")
  const [nombre, setNombre] = useState("")

  const navigate = useNavigate()

  const columns = [
    { Header: "Item", accessor: "item", width: "5%" },
    { Header: "Nombre", accessor: "descripcion", width: "15%" },
    { Header: "Empresa", accessor: "empresa.descripcion", width: "15%" },
    { Header: "Código de Evento", accessor: "codigoEvento", width: "10%" },
    { Header: "Activo", accessor: "activo", width: "10%" },
    { Header: "Acciones", accessor: "action", align: "center", width: "10%" },
  ]

  const fetchEventos = async (setData) => {
    try {
      let url = `${config.api.baseURL}/eventos?`

      if (selectedEmpresas) {
        url += `empresaId=${encodeURIComponent(selectedEmpresas)}`
      }
      if (nombre) {
        url += `&nombre=${encodeURIComponent(nombre)}`
      }

      const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      if (response.status === 200) {
        const result = await response.json()
        addColumns(result)
        setData(result)
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const handleBuscar = async () => {
    await fetchEventos(setData)
  }

  function addColumns(dataColumns) {
    let c = 0
    dataColumns.map((d) => {
      d.action = (
        <MDBox>
          <MDButton
            sx={{ mr: 1 }}
            variant="gradient"
            color="success"
            iconOnly
            onClick={() => handleEdit(d.idEvento)}
          >
            <Icon>edit</Icon>
          </MDButton>
          <MDButton
            sx={{ mr: 1 }}
            variant="gradient"
            color="warning"
            iconOnly
            onClick={() => handleServices(d.idEvento)}
          >
            <Icon>miscellaneous_services_icon</Icon>
          </MDButton>
          <MDButton
            variant="gradient"
            color="error"
            iconOnly
            onClick={() => handleDelete(d.idEvento)}
          >
            <Icon>delete</Icon>
          </MDButton>
        </MDBox>
      )
      d.activo
        ? (d.activo = <Chip label="Si" color="success" variant="outlined" />)
        : (d.activo = <Chip label="No" color="error" variant="outlined" />)
      d.item = ++c
    })
    return dataColumns
  }

  const getEmpresas = async () => {
    try {
      let empUrl = `${config.api.baseURL}/empresas`
      const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
      const response = await fetch(empUrl, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.status === 200) {
        const result = await response.json()
        if (result) {
          setEmpresas(result)
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  function handleDelete(id) {
    Swal.fire({
      title: "¿Está seguro que desea eliminar este evento?",
      text: "¡No podrás revertir esta acción!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        // El usuario confirmó la eliminación, realizar la solicitud DELETE
        let url = `${config.api.baseURL}/eventos/${id}`
        const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

        fetch(url, {
          method: "DELETE",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
          .then((response) => {
            if (response.status === 200) {
              showToast({ title: "Evento eliminado exitosamente", icon: "success" })
              fetchEventos(setData)
            } else {
              response.json().then((result) => {
                let message = "No se pudo eliminar."
                if (Array.isArray(result)) {
                  message = result.join("\n")
                } else if (result.error) {
                  message = result.error
                }

                showToast({ icon: "error", title: "Error", text: message })
              })
            }
          })
          .catch((error) => {
            const err = error.message
            showToast({ icon: "error", title: "Error", text: err })
          })
      }
    })
  }

  const resetValues = () => {
    setSelectedEmpresas("")
    setNombre("")
  }

  const handleClearFilters = () => {
    resetValues() // Reset all filter states
  }

  function handleEdit(id) {
    navigate(`/eventos/${id}`)
  }

  function handleServices(id) {
    navigate(`/eventos/${id}/servicios`)
  }

  const handleNombreSearch = (event) => {
    const term = event.target.value
    setNombre(term)
  }

  useEffect(() => {
    fetchEventos(setData)
    getEmpresas()
  }, [])

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={5} pb={3}>
        <Grid container>
          <Grid item xs={12}>
            <Card sx={{ p: 2, mb: 3 }}>
              <MDTypography variant="h6" color="text" gutterBottom>
                Filtros
              </MDTypography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth>
                    <InputLabel>Empresa</InputLabel>
                    <Select
                      label="Empresa"
                      variant="outlined"
                      fullWidth
                      value={selectedEmpresas}
                      onChange={(e) => setSelectedEmpresas(e.target.value)}
                      sx={{ p: 1.5 }}
                      placeholder="Seleccione.."
                    >
                      <MenuItem value="">Ninguna</MenuItem>
                      {empresas.map((emp) => (
                        <MenuItem key={emp.idEmpresa} value={emp.idEmpresa}>
                          {emp.descripcion}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label="Nombre"
                    variant="outlined"
                    fullWidth
                    value={nombre}
                    onChange={handleNombreSearch}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        handleNombreSearch(event)
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                    <MDBox>
                      <MDButton
                        type="submit"
                        variant="gradient"
                        color="info"
                        onClick={handleBuscar}
                      >
                        Buscar
                      </MDButton>
                      &nbsp;
                      <MDButton
                        type="button"
                        variant="outlined"
                        color="info"
                        onClick={handleClearFilters}
                      >
                        Limpiar
                      </MDButton>
                    </MDBox>

                    <Link to="/eventos/agregar" style={{ textDecoration: "none" }}>
                      <MDButton type="button" variant="gradient" color="success">
                        Agregar
                      </MDButton>
                    </Link>
                  </MDBox>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <MDBox>
              <Card sx={{ p: 2 }}>
                <DataTable
                  isSorted={false}
                  noEndBorder
                  showTotalEntries={false}
                  entriesPerPage={false}
                  canSearch={false}
                  table={{
                    columns: columns,
                    rows: data,
                  }}
                />
              </Card>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  )
}

export default Eventos
